import * as React from 'react'
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { useState } from 'react'

export default function PayPalDisplay() {

  const [donationAmount, setDonationAmount] = useState();
  const [monthlyOrOneTime, setMonthlyOrOneTime] = useState('Monthly');
  const [message, setMessage] = useState("");

  const initialOptions = {
    "client-id": "AbX-aNOETqrozvKzzRLBLHENc59__0lyAGlUmh4xavDUi70JQzJd-iUA1AIkpVdWw1iARmrnpMk04CcY",
    "enable-funding": "paylater,venmo",
    "data-sdk-integration-source": "integrationbuilder_sc",
  };

  function Message({ content }) {
    return <p>{content}</p>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', maxWidth: '800px' }}>
      <div>
        <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', justifyContent: 'left', alignItems: 'left', marginLeft: '20px' }}>
          <div style={{ width: '100px', textAlign: 'left' }}>
            <input
              className="form-check-input fs-bold my-auto mt-4"
              type="radio"
              id="donationAmount"
              name="donationAmount"
              checked={donationAmount === 25}
              onChange={() => setDonationAmount(25)}
            />
            <label className="form-check-label small btn m-n1 p-0 mb-2 my-auto" onClick={() => setDonationAmount(25)}>
              $25
            </label>
          </div>
          <div style={{ width: '100px', textAlign: 'left' }}>
            <input
              className="form-check-input fs-bold my-auto mt-4"
              type="radio"
              id="donationAmount"
              name="donationAmount"
              checked={donationAmount === 50}
              onChange={() => setDonationAmount(50)}
            />
            <label className="form-check-label small btn m-n1 p-0 mb-2 my-auto" onClick={() => setDonationAmount(50)}>
              $50
            </label>
          </div>
          <div style={{ width: '100px', textAlign: 'left' }}>
            <input
              className="form-check-input fs-bold my-auto mt-4"
              type="radio"
              id="donationAmount"
              name="donationAmount"
              checked={donationAmount === 75}
              onChange={() => setDonationAmount(75)}
            />
            <label className="form-check-label small btn m-n1 p-0 mb-2 my-auto" onClick={() => setDonationAmount(75)}>
              $75
            </label>
          </div>
          <div style={{ width: '100px', textAlign: 'left' }}>
            <input
              className="form-check-input fs-bold my-auto mt-4"
              type="radio"
              id="donationAmount"
              name="donationAmount"
              checked={donationAmount === 100}
              onChange={() => setDonationAmount(100)}
            />
            <label className="form-check-label small btn m-n1 p-0 mb-2 my-auto" onClick={() => setDonationAmount(100)}>
              $100
            </label>
          </div>
          <div style={{ width: '100px', textAlign: 'left' }}>
            <input
              className="form-check-input fs-bold my-auto mt-4"
              type="radio"
              id="donationAmount"
              name="donationAmount"
              checked={donationAmount === 150}
              onChange={() => setDonationAmount(150)}
            />
            <label className="form-check-label small btn m-n1 p-0 mb-2 my-auto" onClick={() => setDonationAmount(150)}>
              $150
            </label>
          </div>
          <div style={{ width: '100px', textAlign: 'left' }}>
            <input
              className="form-check-input fs-bold my-auto mt-4"
              type="radio"
              id="donationAmount"
              name="donationAmount"
              checked={donationAmount === 200}
              onChange={() => setDonationAmount(200)}
            />
            <label className="form-check-label small btn m-n1 p-0 mb-2 my-auto" onClick={() => setDonationAmount(200)}>
              $200
            </label>
          </div>
          <div style={{ width: '100px', marginTop: '15px' }}>
            <select
              id="searchPage"
              name="searchPage"
              style={{
                width: '200px', /* Adjust width as needed */
                padding: '5px 10px',
                borderRadius: '5px', /* Rounded corners */
                border: '1px solid #ccc', /* Subtle border */
                backgroundColor: 'white', /* Background color */
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', /* Soft shadow for depth */
                fontSize: '14px', /* Text size */
                color: '#333', /* Text color */
                outline: 'none', /* Removes the default focus outline */
                cursor: 'pointer', /* Changes cursor to pointer on hover */
              }}
              value={donationAmount}
              onChange={(event) => setDonationAmount(event.target.value)}
            >
              <option value={0}>Or, another amount:</option>
              <option value={250}>$250</option>
              <option value={300}>$300</option>
              <option value={350}>$350</option>
              <option value={400}>$400</option>
              <option value={450}>$450</option>
              <option value={500}>$500</option>
            </select>
          </div>
          <div style={{ marginTop: '20px' }}>
            <div style={{ width: '100px', textAlign: 'left' }}>
              <input
                className="form-check-input fs-bold my-auto mt-4"
                type="radio"
                id="monthlyOrOneTime"
                name="monthlyOrOneTime"
                checked={monthlyOrOneTime === 'Monthly'}
                onChange={() => setMonthlyOrOneTime('Monthly')}
              />
              <label className="form-check-label small btn m-n1 p-0 mb-2 my-auto" onClick={() => setMonthlyOrOneTime('Monthly')}>
                Monthly
              </label>
            </div>
            <div style={{ width: '100px', textAlign: 'left', marginBottom: '20px' }}>
              <input
                className="form-check-input fs-bold my-auto mt-4"
                type="radio"
                id="monthlyOrOneTime"
                name="monthlyOrOneTime"
                checked={monthlyOrOneTime === 'One-time'}
                onChange={() => setMonthlyOrOneTime('One-time')}
              />
              <label className="form-check-label small btn m-n1 p-0 mb-2 my-auto" onClick={() => setMonthlyOrOneTime('One-time')}>
                One-time
              </label>
            </div>
          </div>
          {/* <button style={{
          cursor: 'pointer',
          border: 'none',
          width: '100px',
          marginLeft: '100px',
          backgroundColor: '#10c47e', // A red background makes it clear it's a close button
          color: 'white', // White text to contrast against the background
          fontSize: '16px', // Make the text a bit larger for readability
          padding: '5px 10px', // Adjust padding for better button sizing
          borderRadius: '5px', // Rounded corners for a modern look
          outline: 'none', // Remove the outline to keep the focus on the style
          boxShadow: '0 2px 4px rgba(0,0,0,0.2)' // A slight shadow for depth
        }} onClick={() => setActiveVideo('')}>Submit</button> */}

          <PayPalScriptProvider options={initialOptions}>
            <PayPalButtons
              style={{
                shape: "rect",
                //color:'blue' change the default color of the buttons
                layout: "vertical", //default value. Can be changed to horizontal
                maxWidth: '250px'
              }}
              createOrder={async () => {
                try {
                  const response = await fetch("/api/orders", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    // use the "body" param to optionally pass additional order information
                    // like product ids and quantities
                    body: JSON.stringify({
                      cart: [
                        {
                          id: "YOUR_PRODUCT_ID",
                          quantity: "YOUR_PRODUCT_QUANTITY",
                        },
                      ],
                    }),
                  });

                  const orderData = await response.json();

                  if (orderData.id) {
                    return orderData.id;
                  } else {
                    const errorDetail = orderData?.details?.[0];
                    const errorMessage = errorDetail
                      ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                      : JSON.stringify(orderData);

                    throw new Error(errorMessage);
                  }
                } catch (error) {
                  console.error(error);
                  setMessage(`Could not initiate PayPal Checkout...${error}`);
                }
              }}
              onApprove={async (data, actions) => {
                try {
                  const response = await fetch(
                    `/api/orders/${data.orderID}/capture`,
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                    },
                  );

                  const orderData = await response.json();
                  // Three cases to handle:
                  //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                  //   (2) Other non-recoverable errors -> Show a failure message
                  //   (3) Successful transaction -> Show confirmation or thank you message

                  const errorDetail = orderData?.details?.[0];

                  if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
                    // (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                    // recoverable state, per https://developer.paypal.com/docs/checkout/standard/customize/handle-funding-failures/
                    return actions.restart();
                  } else if (errorDetail) {
                    // (2) Other non-recoverable errors -> Show a failure message
                    throw new Error(
                      `${errorDetail.description} (${orderData.debug_id})`,
                    );
                  } else {
                    // (3) Successful transaction -> Show confirmation or thank you message
                    // Or go to another URL:  actions.redirect('thank_you.html');
                    const transaction =
                      orderData.purchase_units[0].payments.captures[0];
                    setMessage(
                      `Transaction ${transaction.status}: ${transaction.id}. See console for all available details`,
                    );
                    console.log(
                      "Capture result",
                      orderData,
                      JSON.stringify(orderData, null, 2),
                    );
                  }
                } catch (error) {
                  console.error(error);
                  setMessage(
                    `Sorry, your transaction could not be processed...${error}`,
                  );
                }
              }}
            />
          </PayPalScriptProvider>
        </div>
        <Message content={message} />
      </div>
    </div>
  )
}
